
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pagepath]",
      function () {
        return require("private-next-pages/[...pagepath]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...pagepath]"])
      });
    }
  